/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from './http-client'

export class FileExportClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags FileExport
   * @summary Экспортировать файл 3д интерпретации горизонта
   * @request GET:/bff/FileExport/export-interpretation-3d/{interpretationId}
   * @secure
   */
  fileExportDownloadInterpretationHorizon3D = (
    interpretationId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/bff/FileExport/export-interpretation-3d/${interpretationId}`,
      method: 'GET',
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags FileExport
   * @summary Получить имя экспортируемого файла
   * @request GET:/bff/FileExport/export-interpretation-3d-name/{interpretationId}
   * @secure
   */
  fileExportGetHorizonInterpretation3DFileName = (
    interpretationId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/bff/FileExport/export-interpretation-3d-name/${interpretationId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags FileExport
   * @summary Экспортировать файл 3д интерпретации горизонта
   * @request GET:/bff/FileExport/export-interpretation-2d/{interpretationId}
   * @secure
   */
  fileExportDownloadInterpretationHorizon2D = (
    interpretationId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/bff/FileExport/export-interpretation-2d/${interpretationId}`,
      method: 'GET',
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags FileExport
   * @summary Получить имя экспортируемого файла
   * @request GET:/bff/FileExport/export-interpretation-2d-name/{interpretationId}
   * @secure
   */
  fileExportGetHorizonInterpretation2DFileName = (
    interpretationId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/bff/FileExport/export-interpretation-2d-name/${interpretationId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags FileExport
   * @summary Получить имя экспортируемого файла разлома в формате charisma
   * @request GET:/bff/FileExport/export-fault/{faultId}/chm/filename
   * @secure
   */
  fileExportGetFileNameFaultChm = (faultId: string, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/bff/FileExport/export-fault/${faultId}/chm/filename`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags FileExport
   * @summary Экспортировать разлом в формате charisma
   * @request GET:/bff/FileExport/export-fault/{faultId}/chm
   * @secure
   */
  fileExportDownloadFaultChm = (faultId: string, params: RequestParams = {}) =>
    this.http.request<File, any>({
      path: `/bff/FileExport/export-fault/${faultId}/chm`,
      method: 'GET',
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags FileExport
   * @summary Экспортировать разлом в формате charisma с привязкой к 3D съемке (кубу)
   * @request GET:/bff/FileExport/export-fault/{faultId}/survey3d/{survey3dId}/chm
   * @secure
   */
  fileExportDownloadFaultChmWithBinding = (
    faultId: string,
    survey3DId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/bff/FileExport/export-fault/${faultId}/survey3d/${survey3DId}/chm`,
      method: 'GET',
      secure: true,
      ...params,
    })
}
